import { render, staticRenderFns } from "./CampaignsApproved.vue?vue&type=template&id=3ec7dedb&scoped=true"
import script from "./CampaignsApproved.vue?vue&type=script&lang=js"
export * from "./CampaignsApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec7dedb",
  null
  
)

export default component.exports